import { lazy } from "react";

// Route pages load as their own small files; after the app opens they are fetched quietly so taps stay instant.
const loaders = [];
export function page(load) {
  loaders.push(load);
  return lazy(load);
}

export function preloadPages() {
  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
  idle(() => loaders.reduce((p, load) => p.then(() => load().catch(() => null)), Promise.resolve()));
}
